import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import localization from '../../../shared/strings';
import Tooltip from '../../Tooltip/Tooltip';
import ProductStatusSelect from '../ProductStatusSelect';
import { formatVariantOptionsSummary } from '../helpers/formatVariantOptionsSummary';
import styles from './styles.module.scss';

const l10n = localization.PRODUCT_INFO;

const VariantContextBlock = ({
  parentTitle,
  parentSku,
  parentStatus,
  availableOptions,
  variantOptions,
  onNavigateToParent,
}) => {
  const optionsSummary = useMemo(() => formatVariantOptionsSummary({
    availableOptions,
    variantOptions,
  }), [availableOptions, variantOptions]);

  return (
    <div className={styles.contextBlock} data-qa="variantContextBlock">
      <div className={styles.row}>
        <span className={styles.label}>{l10n.parentProduct}</span>
        <button
          type="button"
          className={styles.parentLink}
          onClick={onNavigateToParent}
        >
          {parentTitle}
        </button>
      </div>
      <If condition={parentSku}>
        <div className={styles.row}>
          <span className={styles.label}>{l10n.parentSku}</span>
          <span className={styles.value}>{parentSku}</span>
        </div>
      </If>
      <div className={styles.row}>
        <span className={styles.label}>{l10n.statusLabel}</span>
        <div className={styles.statusWrap}>
          <Tooltip content={l10n.inheritedStatusTooltip} placement="top">
            <span className={styles.statusTooltipTrigger}>
              <ProductStatusSelect
                productStatus={parentStatus}
                readOnly
              />
            </span>
          </Tooltip>
        </div>
      </div>
      <If condition={optionsSummary}>
        <div className={styles.row}>
          <span className={styles.label}>{l10n.optionsLabel}</span>
          <span className={styles.value}>{optionsSummary}</span>
        </div>
      </If>
    </div>
  );
};

VariantContextBlock.propTypes = {
  parentTitle: PropTypes.string,
  parentSku: PropTypes.string,
  parentStatus: PropTypes.string,
  availableOptions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string),
  })),
  variantOptions: PropTypes.objectOf(PropTypes.string),
  onNavigateToParent: PropTypes.func.isRequired,
};

VariantContextBlock.defaultProps = {
  parentTitle: '',
  parentSku: '',
  parentStatus: 'draft',
  availableOptions: [],
  variantOptions: {},
};

export default VariantContextBlock;
